<script>
import { Line } from 'vue-chartjs';

export default {
    extends: Line,

    props: {
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            chartData: {},
            chartOptions: {},
        };
    },

    mounted() {
        let opts = {
            responsive: true,
            maintainAspectRatio: false,
            elements: {
                line: {
                    tension: 0,
                },
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Date',
                    },
                    time: {
                        unit: 'month',
                        tooltipFormat: 'MMM YYYY',
                    },
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Data',
                    },
                }],
            },
        };

        let initialRender = () => {
            this.renderChart({
                datasets: this.chartData,
            }, opts);
        };

        this.getData(initialRender);
    },

    methods: {
        getData(callback = null) {
            window.axios.get(this.url)
                .then(response => {
                    console.log(response);
                    this.chartData = response.data;

                    if (callback) {
                        callback();
                    }
                })
                .catch(err => {
                    alert('Oops, sth wrong');
                    console.log(err);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/SimpleChart.vue